import React, {useState, useEffect, useRef} from 'react';
import {useHistory} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {Calendar} from "primereact/calendar";
import axios from "axios";
import moment from "moment";

const ScheduleListComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  // const {module, entity, action, id} = useParams();
  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [checkinRange, setCheckinRange] = useState(null);
  const [checkoutRange, setCheckoutRange] = useState(null);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1
  });
  // const [expandedRows, setExpandedRows] = useState(null);

  let loadLazyTimeout = null;
  const clearFieldSearch = (sp, field) => {
    sp.delete(`search[${field}]`);
    sp.delete(`search[${field}][operator]`);
    sp.delete(`search[${field}][operator][]`);
    sp.delete(`search[${field}][value]`);
    sp.delete(`search[${field}][value][]`);
  };
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      const baseQuery = window.App.transformQueryParams(lazyParams) || '';
      const sp = new URLSearchParams(baseQuery.startsWith('?') ? baseQuery.slice(1) : baseQuery);
      clearFieldSearch(sp, 'date_from');
      clearFieldSearch(sp, 'date_until');
      addRangeSearch(sp, 'date_from', checkinRange);
      addRangeSearch(sp, 'date_until', checkoutRange);
      if (props.schedulegroupId) {
        sp.set('search[schedule_group][operator]', '=');
        sp.set('search[schedule_group][value]', props.schedulegroupId);
      }
      const query = sp.toString() ? `?${sp.toString()}` : '';
      apiCall('get', '/api/v2/schedule' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setSchedules(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
           setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    if (_lazyParams.filters) {
      delete _lazyParams.filters['date_from'];
      delete _lazyParams.filters['date_until'];
    }
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const actionBodyTemplate = (rowData) => {
    const scheduleDate = rowData.date_from ? moment(rowData.date_from).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');

    return (
      <React.Fragment>
        <Button icon="pi pi-eye" className=' p-mr-2'
                tooltip={t('view')} tooltipOptions={{position: 'left'}}
                onClick={() => {
                  // history.push(
                  //   '/production/schedule-item?scheduleId=' +
                  //   rowData.id +
                  //   '&scheduleDate=' +
                  //   scheduleDate
                  // )
                  history.push('/production/schedule-group/read/' + rowData.id + '?scheduleGroupType=' + props.scheduleGroupType)
                }}/>
        <Button icon="pi pi-calendar" className='p-button p-mr-2'
                tooltip="Műszak beosztás" tooltipOptions={{position: 'left'}}
                onClick={() => {
                  history.push(
                    '/production/schedule-item?scheduleId=' +
                    rowData.id +
                    '&scheduleDate=' +
                    scheduleDate
                  )
                }}/>
        <Button icon="pi pi-trash" className="p-button-danger"
                tooltip={t('delete')} tooltipOptions={{position: 'left'}}
                onClick={() => {
                  if (window.confirm('A törlés megerősítésére van szükség!')) {
                    setLoading(true);
                    apiCall('delete', '/api/v2/schedule/' + rowData.id)
                      .then(response => {
                        window.App.toastShow('success', 'Sikeres törlés!');
                      })
                      .catch(error => {
                        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                      })
                      .finally(() => {
                        setLoading(false);
                      })
                  }
                }}
        />
      </React.Fragment>
    );
  }

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const addRangeSearch = (sp, field, range) => {
    const [from, to] = range || [];
    if (!from) return;
    const fromStr = moment(from).format('YYYY-MM-DD 00:00:00');
    if (!to) {
      sp.set(`search[${field}][operator]`, '>=');
      sp.set(`search[${field}][value]`, fromStr);
      return;
    }
    const toStr = moment(to).format('YYYY-MM-DD 23:59:59');
    sp.set(`search[${field}][operator]`, 'between');
    sp.set(`search[${field}][value]`, `${fromStr},${toStr}`);
  };

  const onDateRangeChange = (field, range) => {
    if (field === 'date_from') setCheckinRange(range);
    if (field === 'date_until') setCheckoutRange(range);
    setLazyParams(prev => ({
      ...prev,
      first: 0,
      page: 0
    }));
  };

  const clearDateRange = (field) => {
    if (field === 'date_from') setCheckinRange(null);
    if (field === 'date_until') setCheckoutRange(null);
    setLazyParams(prev => ({
      ...prev,
      first: 0,
      page: 0
    }));
  };

  const dateRangeFilterTemplate = (field, placeholder=t('dateRangePlaceholder')) => {
    const value = field === 'date_from' ? checkinRange : checkoutRange;
    return (
      <span style={{position: 'relative', display: 'block', width: '100%'}}>
        <Calendar
          value={value}
          selectionMode="range"
          readOnlyInput
          showIcon
          dateFormat="yy-mm-dd"
          appendTo={document.body}
          placeholder={placeholder}
          onChange={(e) => onDateRangeChange(field, e.value)}
          className="w-100"
        />
        {value && value[0] && (
          <button
            type="button"
            onClick={() => clearDateRange(field)}
            className="p-link"
            style={{
              position: 'absolute',
              right: '-1.75rem',
              top: '50%',
              transform: 'translateY(-50%)',
              padding: 0,
              lineHeight: 1,
              zIndex: 5
            }}
          >
            <i className="pi pi-times" />
          </button>
        )}
      </span>
    );
  };

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderScheduleList])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={schedules} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
      >
        <Column field="date_from" header={t('columnShiftStart')} sortable filter  showFilterMenu={false}
                filterElement={dateRangeFilterTemplate('date_from')} className={"p-text-nowrap"}
                body={(rowData) => {
                  return (
                    <>{window.App.formatDateValue(rowData.date_from)}</>
                  )
                }}></Column>
        <Column field="date_until" header={t('columnShiftEnd')} sortable filter showFilterMenu={false}
                filterElement={dateRangeFilterTemplate('date_until')} className={"p-text-nowrap"}
                body={(rowData) => {
                  return (
                    <>{window.App.formatDateValue(rowData.date_until)}</>
                  )
                }}></Column>
        {props.type === 'EMPLOYEE_CAPACITY' &&
          <Column field="headcount" header={t('columnHeadcount')} sortable></Column>
        }
        {props.type === 'MACHINE_CAPACITY' &&
          <Column field="count" header={t('columnCycle')} sortable></Column>
        }
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(ScheduleListComponent);
